export function productsSlider() {
    let $slider = $(".products-slider");
    $slider.slick({
        infinite: true,
        cssEase: "linear",
        arrows: false,
        dots: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    centerMode: true,
                    centerPadding: '180px',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    dots: false,
                    centerMode: true,
                    centerPadding: '260px',
                    slidesToShow: 1,
                    autoplay: true,
                    autoplaySpeed: 3000
                }
            },
            {
                breakpoint: 1440,
                settings: {
                    dots: false,
                    centerMode: true,
                    centerPadding: '485px',
                    slidesToShow: 1,
                    autoplay: true,
                    autoplaySpeed: 3000
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/productsSlider.js